'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    StampStore = require('./StampStore'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    parseStampSegment = require('../utils/parseStampSegment'),
    { createIndexedListStore, createListActionHandler } = PaginatedStoreUtils;

var ZinePendingStampStore = createIndexedListStore({
  getStamps(zineSlug) {
    return this.getIds(zineSlug).map(StampStore.get);
  }
});

function getList(zineSlug) {
  return ZinePendingStampStore.getList(zineSlug);
}

function emitChange() {
  ZinePendingStampStore.emitChange();
}

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_ZINE_PENDING_STAMPS,
  error: ActionTypes.REQUEST_ZINE_PENDING_STAMPS_ERROR,
  success: ActionTypes.REQUEST_ZINE_PENDING_STAMPS_SUCCESS,
  preload: ActionTypes.PRELOAD_ZINE_PENDING_STAMPS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([StampStore.dispatchToken]);

  var action = payload.action,
      zineSlug = action.zineSlug,
      stampSegment = action.stampSegment,
      stampId,
      list;

  if (!zineSlug) {
    return;
  }

  list = getList(zineSlug);

  if (stampSegment) {
    stampId = parseStampSegment(stampSegment).stampId;
  }

  switch (action.type) {
  case ActionTypes.ADD_STAMP_TO_ZINE_SUCCESS:
  case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
    list.remove(stampId);
    break;

  case ActionTypes.REMOVE_STAMP_FROM_ZINE_SUCCESS:
  case ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS:
    list.remove(stampId);
    break;

  default:
    handleListAction(action, list, emitChange);
    break;
  }
});

module.exports = ZinePendingStampStore;


/** WEBPACK FOOTER **
 ** ./stores/ZinePendingStampStore.js
 **/